__turbopack_context__.v({
  "eds-example-grid-coloring": "EventCardsBucket-module-scss-module__L_HXAa__eds-example-grid-coloring",
  "eds-example-grid-content": "EventCardsBucket-module-scss-module__L_HXAa__eds-example-grid-content",
  "eds-example-sidebar-content": "EventCardsBucket-module-scss-module__L_HXAa__eds-example-sidebar-content",
  "eds-g-cell": "EventCardsBucket-module-scss-module__L_HXAa__eds-g-cell",
  "eds-g-sidebar": "EventCardsBucket-module-scss-module__L_HXAa__eds-g-sidebar",
  "eds-g-view": "EventCardsBucket-module-scss-module__L_HXAa__eds-g-view",
  "fade-in": "EventCardsBucket-module-scss-module__L_HXAa__fade-in",
  "fade-out": "EventCardsBucket-module-scss-module__L_HXAa__fade-out",
  "feedCardCell": "EventCardsBucket-module-scss-module__L_HXAa__feedCardCell",
  "feedEventsBucket": "EventCardsBucket-module-scss-module__L_HXAa__feedEventsBucket",
  "feedEventsBucket__separator": "EventCardsBucket-module-scss-module__L_HXAa__feedEventsBucket__separator",
});
